<template>
    <section class="slide">
        <Splide :options="options" class="splide">
            <SplideSlide v-for="(data, i) in sliders" :key="i" class="image-box">
                <div class="img">
                    <img :src="data.url" :alt="data.id">
                </div>
            </SplideSlide>
        </Splide>
    </section>
</template>
<script>
    import data from '../../data/datas.js'
    import '@splidejs/vue-splide/css';
    export default {
        name: 'mobileSlide',
        data() {
            return{
                sliders: data[6].slide,
                options: {
                    rewind: true,
                    gap: '10px',
                    perMove: 1,
                    pagination: false,
                    drag: true,
                    type: 'loop',
                    padding: '2rem',
                    arrows: false,
                    perPage: 4,
                    interval: 2000,
                    breakpoints: {
                        1200: {
                            perPage: 3
                        },
                        800: {
                            perPage: 2
                        },
                        567: {
                            perPage: 1
                        }
                    }
                }
            }
        },
    }
</script>
<style scoped>
    .slide{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 3rem 1rem;
        background-color: #fff;
        margin-bottom: 6rem;
    }
    .slide .splide {
        position: relative;
    }
    .slide .image-box{
        position: relative;
        display: flex;
        gap: 10px;
    }

    .image-box .img{
        position: relative;
        width: 100%;
        width: 300px;
        height: 260px;
        /* margin: 1rem; */
        display: flex;
        gap: 10px;
    }
    .image-box .img img{
        position: relative;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    @media screen and (min-width:1010px) {
        .slide{
            background-color: inherit;
        }

        .slide .image-box{
            height: 320px;
        }
        .image-box .img{
            width: 300px;
            height: 300px;
        }
    }
</style>